// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.vendor.SalesRepresentativesSummaryResponse */
/* istanbul ignore next */
@GandalfModel
export class SalesRepresentativesSummaryResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	companyName!: string | null;

	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: String })
	preferredPhone!: string | null;

	@GandalfConstantDecorator(constants.SalesRepresentativeStatus)
	@GandalfProperty({ designType: constants.SalesRepresentativeStatus })
	status!: constants.SalesRepresentativeStatus | null;

}
